import { makeAutoObservable } from "mobx";
export class RegistrationsStore {
    registrations = [];
    alsoInactive = false;
    pageNumber = 0;
    allEntriesLoaded = false;
    selectedRegistration = null;
    history = null;
    constructor() {
        makeAutoObservable(this, {
            setRegistrations: true,
            appendRegistrations: true,
            setRegistration: true,
            setSelectedRegistration: true,
            setHistory: true,
            setAlsoInactive: true,
        });
    }
    // first batch
    setRegistrations(regs, allEntriesLoaded) {
        this.registrations = regs;
        this.pageNumber = 0;
        this.allEntriesLoaded = allEntriesLoaded;
    }
    // paginated batch
    appendRegistrations(regs, allEntriesLoaded, pageNumber) {
        this.registrations.push(...regs);
        this.pageNumber = pageNumber;
        this.allEntriesLoaded = allEntriesLoaded;
    }
    setRegistration(newReg) {
        // if there is no selected registration, we set the new one as selected
        // or if there is selected registration, update it with new reg - e.g. opened detail of registration
        if ((this.selectedRegistration === null)
            || (this.selectedRegistration?.registrationId === newReg.registrationId)) {
            this.setSelectedRegistration(newReg);
        }
        if (!this.registrations) {
            return;
        }
        const index = this.registrations.findIndex((reg) => reg.registrationId === newReg.registrationId);
        if (index !== -1) {
            this.registrations[index] = newReg;
        }
    }
    setSelectedRegistration(reg) {
        this.selectedRegistration = reg;
        // clear the history for new registration
        this.history = null;
    }
    setHistory(history) {
        this.history = history;
    }
    setAlsoInactive(alsoInactive) {
        this.alsoInactive = alsoInactive;
    }
}
